import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MaterialComponentsModule } from "../material-components.module";
import { SharedModule } from "../shared/shared.module";

// Layout components
import { LayoutComponent } from "./layout/layout.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { FooterComponent } from "./footer/footer.component";
import { MenuComponent } from "./menu/menu.component";
import { MobileMenuComponent } from "./mobile-menu/mobile-menu.component";
import { ProductsDropdownComponent } from "./products-dropdown/products-dropdown.component";
import { ProfileComponent } from "./profile-dropdown/profile.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialComponentsModule,
    SharedModule,
  ],
  declarations: [
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    MenuComponent,
    MobileMenuComponent,
    ProductsDropdownComponent,
    ProfileComponent,
  ],
  exports: [
    LayoutComponent,
    HeaderComponent,
    SidebarComponent,
  ],
})
export class LayoutModule {}
